import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function PatreonIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 26">
      <path d="M15.386.524c-4.764 0-8.64 3.876-8.64 8.64 0 4.75 3.876 8.613 8.64 8.613 4.75 0 8.614-3.864 8.614-8.613C24 4.4 20.136.524 15.386.524M.003 23.537h4.22V.524H.003" />
    </SvgIcon>
  );
}
